module.exports = __webpack_public_path__ + "img/refresh.3d209ce4.svg";